(function(){
  var pendingColor=null;
  var urlColorDone=false;
  function initSizeDropdown(){
    var fs=[].slice.call(document.querySelectorAll('fieldset.variant-option')).filter(function(f){var l=f.querySelector('legend');return l&&/size/i.test(l.textContent);})[0];
    if(!fs||fs.dataset.vexDropped)return;
    var inputs=[].slice.call(fs.querySelectorAll('input[type=radio]'));
    if(inputs.length<2)return;
    var sel=document.createElement('select');
    sel.className='vex-size-select';sel.setAttribute('aria-label','Select size');
    var ph=document.createElement('option');ph.textContent='Select Size';ph.value='';ph.disabled=true;sel.appendChild(ph);
    var anyChecked=false;
    inputs.forEach(function(inp){
      var lbl=fs.querySelector('label[for="'+inp.id+'"]');
      var txt=(lbl?lbl.textContent:inp.value).replace(/\s+/g,' ').trim();
      var o=document.createElement('option');o.value=inp.value;o.textContent=inp.disabled?(txt+' — sold out'):txt;
      if(inp.disabled)o.disabled=true;
      if(inp.checked){o.selected=true;anyChecked=true;}
      sel.appendChild(o);
    });
    if(!anyChecked)ph.selected=true;
    sel.addEventListener('change',function(){
      var inp=inputs.filter(function(i){return i.value===sel.value;})[0];
      if(!inp)return;
      var lbl=fs.querySelector('label[for="'+inp.id+'"]');
      if(lbl){lbl.click();}else{inp.checked=true;inp.dispatchEvent(new Event('change',{bubbles:true}));}
    });
    fs.dataset.vexDropped='1';fs.classList.add('vex-size-dropped');fs.appendChild(sel);
  }
  function relabelCart(){
    [].slice.call(document.querySelectorAll('.add-to-cart-button')).forEach(function(btn){
      var nodes=[].slice.call(btn.querySelectorAll('*')).filter(function(e){return e.children.length===0&&/add to cart/i.test(e.textContent);});
      if(nodes.length){nodes.forEach(function(n){n.textContent=n.textContent.replace(/add to cart/i,'Add to bag');});}
      else if(btn.children.length===0&&/add to cart/i.test(btn.textContent)){btn.textContent='Add to bag';}
    });
  }
  function colourInputs(scope){
    return [].slice.call(scope.querySelectorAll('.variant-option--swatches input[type=radio]')).filter(function(i){
      return !i.closest('quick-add-dialog')&&!i.closest('.quick-add-modal');
    });
  }
  function pickSwatch(scope,colour){
    var want=String(colour||'').trim().toLowerCase();if(!want)return false;
    var inputs=[].slice.call(scope.querySelectorAll('.variant-option--swatches input[type=radio]'));
    var target=inputs.filter(function(inp){
      var lbl=scope.querySelector('label[for="'+inp.id+'"]');
      var c=(inp.value||inp.getAttribute('data-value')||(lbl?lbl.textContent:'')||'').trim().toLowerCase();
      return c===want;
    })[0];
    if(!target)return false;
    if(!target.checked){
      var lbl=scope.querySelector('label[for="'+target.id+'"]')||target.closest('label');
      /* 2026-09-18: clicking the label focuses the radio, and Android Chrome scrolls a focused input into view,
         so the page jumped down to the size/colour picker and hid the photo. Keep the scroll position and
         drop the focus, for the URL colour, the strip squares and the swipe alike. */
      var y=window.pageYOffset||document.documentElement.scrollTop||0;
      var keep=function(){
        var ae=document.activeElement;
        if(ae&&ae!==document.body&&ae.matches&&ae.matches('.variant-option input, .variant-option label')){try{ae.blur();}catch(e){}}
        if(Math.abs((window.pageYOffset||0)-y)>2){try{window.scrollTo({top:y,left:0,behavior:'instant'});}catch(e){window.scrollTo(0,y);}}
      };
      if(lbl){lbl.click();}else{target.checked=true;target.dispatchEvent(new Event('change',{bubbles:true}));}
      keep();
      try{requestAnimationFrame(keep);}catch(e){}
      setTimeout(keep,60);setTimeout(keep,200);
    }
    return true;
  }
  function applyModalColor(){
    if(!pendingColor)return;
    var dlg=document.querySelector('quick-add-dialog, .quick-add-modal, dialog[open]');
    if(!dlg)return;
    if(dlg.dataset.vexApplied===pendingColor)return;
    if(pickSwatch(dlg,pendingColor))dlg.dataset.vexApplied=pendingColor;
  }
  function applyUrlColor(){
    if(urlColorDone)return;
    var col=null;
    try{col=new URLSearchParams(location.search).get('vexcolor');}catch(e){}
    if(!col){urlColorDone=true;return;}
    var main=document.querySelector('.product-information')||document.body;
    if(pickSwatch(main,col.replace(/-/g,' ')))urlColorDone=true;
  }
  function syncShareUrl(){
    if(!/\/products\//.test(location.pathname))return;
    var main=document.querySelector('.product-information');if(!main)return;
    var colInp=colourInputs(main).filter(function(i){return i.checked;})[0];
    var idInp=main.querySelector('product-form-component form[action*="/cart/add"] input[name="id"]')||main.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"][type=hidden]');
    var params;
    try{params=new URLSearchParams(location.search);}catch(e){return;}
    params.delete('preview_theme_id');params.delete('_fd');params.delete('pb');
    var changed=false;
    if(colInp&&colInp.value){
      var v=colInp.value.trim().toLowerCase().replace(/\s+/g,'-');
      if(params.get('vexcolor')!==v){params.set('vexcolor',v);changed=true;}
    }
    if(idInp&&idInp.value){
      if(params.get('variant')!==String(idInp.value)){params.set('variant',String(idInp.value));changed=true;}
    }
    if(!changed)return;
    var qs=params.toString();
    var full=location.origin+location.pathname+(qs?'?'+qs:'');
    try{history.replaceState(history.state,'',location.pathname+(qs?'?'+qs:'')+location.hash);}catch(e){}
    try{
      var can=document.querySelector('link[rel="canonical"]');
      if(can&&idInp&&idInp.value)can.setAttribute('href',location.origin+location.pathname+'?variant='+idInp.value);
      var og=document.querySelector('meta[property="og:url"]');
      if(og)og.setAttribute('content',full);
    }catch(e){}
  }

  /* ===== 2026-09-06 colour switching v2 =====
     One photo: the selected colour. A horizontal swatch strip right under the photo (thumb reach on a phone,
     one hand). Swipe left/right on the photo = next/previous colour. The floating rail and the gallery dots
     are retired. The native Color picker under the price still works and stays in sync. */
  var colourMedia=null;   // { 'black': mediaId, ... } from /products/<handle>.js
  var mediaFetchStarted=false;
  function loadColourMedia(){
    if(mediaFetchStarted||!/\/products\//.test(location.pathname))return;
    mediaFetchStarted=true;
    var handle=location.pathname.split('/products/')[1].split(/[/?#]/)[0];
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
      var idx=-1;
      (p.options||[]).forEach(function(o,i){if(/colou?r/i.test(o.name||o))idx=i;});
      if(idx<0)idx=0;
      var map={};
      (p.variants||[]).forEach(function(v){
        var key=String(v.options?v.options[idx]:(v['option'+(idx+1)]||'')).trim().toLowerCase();
        var mid=v.featured_media&&v.featured_media.id;
        if(key&&mid&&!map[key])map[key]=String(mid);
      });
      colourMedia=map;run();
    }).catch(function(){colourMedia={};});
  }
  function currentColour(){
    var main=document.querySelector('.product-information')||document.body;
    var c=colourInputs(main).filter(function(i){return i.checked;})[0];
    return c?String(c.value).trim().toLowerCase():null;
  }
  function focusGallery(){
    var media=document.querySelector('.product-information__media');if(!media||!colourMedia)return;
    var col=currentColour();var want=col?colourMedia[col]:null;
    if(!want)return;
    var slides=[].slice.call(media.querySelectorAll('slideshow-slide'));
    var gridItems=[].slice.call(media.querySelectorAll('.media-gallery__grid > li'));
    function mid(el){var m=el.matches&&el.matches('[data-media-id]')?el:el.querySelector('[data-media-id]');return m?String(m.getAttribute('data-media-id')):null;}
    var hit=slides.some(function(s){return mid(s)===want;})||gridItems.some(function(s){return mid(s)===want;});
    if(!hit)return;   // unknown mapping: never blank the gallery
    slides.forEach(function(s){s.classList.toggle('vex-off',mid(s)!==want);});
    gridItems.forEach(function(s){s.classList.toggle('vex-off',mid(s)!==want);});
  }
  function buildColourStrip(){
    if(!/\/products\//.test(location.pathname))return;
    var media=document.querySelector('.product-information__media');if(!media)return;
    var existing=document.querySelector('.vex-cwrap');
    if(existing&&existing.parentElement===media)return;
    if(existing)existing.remove();
    var main=document.querySelector('.product-information')||document.body;
    var inputs=colourInputs(main);
    if(inputs.length<2)return;
    var wrap=document.createElement('div');wrap.className='vex-cwrap';
    var nameEl=document.createElement('div');nameEl.className='vex-cstrip__name';nameEl.setAttribute('aria-live','polite');
    nameEl.innerHTML='<span class="vex-cstrip__name-k">Colour</span> <span class="vex-cstrip__name-v"></span>';
    wrap.appendChild(nameEl);
    var strip=document.createElement('div');strip.className='vex-cstrip';strip.setAttribute('role','group');strip.setAttribute('aria-label','Choose colour');
    inputs.forEach(function(inp){
      var lbl=(inp.id&&document.querySelector('label[for="'+inp.id+'"]'))||inp.closest('label');if(!lbl)return;
      var b=document.createElement('button');b.type='button';b.className='vex-cstrip__b';
      b.setAttribute('aria-label',inp.value);b.dataset.vexVal=inp.value;
      var sw=lbl.querySelector('.swatch')||lbl.querySelector('[class*="swatch"]')||lbl.querySelector('span');
      var clone=(sw||lbl).cloneNode(true);[].slice.call(clone.querySelectorAll('input')).forEach(function(x){x.remove();});
      b.appendChild(clone);
      if(inp.checked)b.classList.add('is-on');
      b.addEventListener('click',function(){pickSwatch(document.querySelector('.product-information')||document.body,b.dataset.vexVal);});
      strip.appendChild(b);
    });
    if(strip.children.length<2)return;
    wrap.appendChild(strip);
    var hint=document.createElement('div');hint.className='vex-cstrip__hint';hint.textContent='Swipe the photo or tap a square to change the colour';wrap.appendChild(hint);
    media.appendChild(wrap);
    // edge arrows on the photo (mobile): a visible cue that the photo changes colour, and a tap target
    if(!media.querySelector('.vex-cnav')){
      ['prev','next'].forEach(function(dir){
        var a=document.createElement('button');a.type='button';a.className='vex-cnav vex-cnav--'+dir;
        a.setAttribute('aria-label',dir==='next'?'Next colour':'Previous colour');
        a.innerHTML=dir==='next'?'&#8250;':'&#8249;';
        a.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();stepColour(dir==='next'?1:-1);});
        media.appendChild(a);
      });
    }
  }
  function syncStrip(){
    var strip=document.querySelector('.vex-cstrip');if(!strip)return;
    var col=currentColour();
    var nv=document.querySelector('.vex-cstrip__name-v');
    if(nv){var cur=colourInputs(document.querySelector('.product-information')||document.body).filter(function(i){return i.checked;})[0];var nm=cur?cur.value:'';if(nv.textContent!==nm)nv.textContent=nm;}
    var changed=strip.dataset.vexLast!==(col||'');
    strip.dataset.vexLast=col||'';
    [].slice.call(strip.querySelectorAll('.vex-cstrip__b')).forEach(function(b){
      var on=!!col&&String(b.dataset.vexVal).trim().toLowerCase()===col;
      b.classList.toggle('is-on',on);
      // scroll ONLY the strip, horizontally, and only when the colour really changed (scrollIntoView moved the whole page)
      if(on&&changed&&strip.scrollWidth>strip.clientWidth){try{strip.scrollTo({left:Math.max(0,b.offsetLeft-strip.clientWidth/2+b.offsetWidth/2),behavior:'smooth'});}catch(e){strip.scrollLeft=Math.max(0,b.offsetLeft-strip.clientWidth/2);}}
    });
  }
  function stepColour(dir){
    var main=document.querySelector('.product-information')||document.body;
    var inputs=colourInputs(main).filter(function(i){return !i.disabled;});
    if(inputs.length<2)return;
    var idx=inputs.findIndex(function(i){return i.checked;});
    var next=inputs[(idx+dir+inputs.length)%inputs.length];
    pickSwatch(main,next.value);
  }
  function initSwipe(){
    var media=document.querySelector('.product-information__media');
    if(!media||media.dataset.vexSwipe)return;
    media.dataset.vexSwipe='1';
    var x0=null,y0=null,t0=0;
    media.addEventListener('touchstart',function(e){if(e.touches.length!==1)return;x0=e.touches[0].clientX;y0=e.touches[0].clientY;t0=Date.now();},{passive:true});
    media.addEventListener('touchend',function(e){
      if(x0===null)return;
      var t=e.changedTouches[0];var dx=t.clientX-x0,dy=t.clientY-y0;x0=null;
      if(Date.now()-t0>800)return;
      if(Math.abs(dx)>48&&Math.abs(dy)<40){stepColour(dx<0?1:-1);}
    },{passive:true});
    media.addEventListener('keydown',function(e){if(e.key==='ArrowRight')stepColour(1);if(e.key==='ArrowLeft')stepColour(-1);});
  }

  function run(){try{initSizeDropdown();relabelCart();applyModalColor();applyUrlColor();syncShareUrl();loadColourMedia();buildColourStrip();syncStrip();focusGallery();initSwipe();}catch(e){}}
  document.addEventListener('click',function(e){
    var qa=e.target.closest&&e.target.closest('.quick-add__button');
    if(qa){var card=e.target.closest('product-card');pendingColor=card?(card.dataset.vexColor||null):null;
      var dlg=document.querySelector('quick-add-dialog, .quick-add-modal');if(dlg)delete dlg.dataset.vexApplied;}
  },true);
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
  var t;var obs=new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,50);});
  obs.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('change',function(e){
    if(e.target&&e.target.matches&&e.target.matches('.variant-option input[type=radio]')){[120,350,700,1200,2000,3000].forEach(function(ms){setTimeout(run,ms);});}
  });
  try{
    ['replaceState','pushState'].forEach(function(m){
      var orig=history[m];
      history[m]=function(){var r=orig.apply(this,arguments);setTimeout(run,0);setTimeout(run,60);return r;};
    });
  }catch(e){}
})();
